"use client";
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import TeamImg1 from '../../assets/images/team/team-1-1.jpg'
import TeamImg2 from '../../assets/images/team/team-1-2.jpg'
import TeamImg3 from '../../assets/images/team/team-1-3.jpg'
import TeamImg4 from '../../assets/images/team/team-1-4.jpg'
import TeamImg5 from '../../assets/images/team/team-1-5.jpg'
import TeamImg6 from '../../assets/images/team/team-1-6.jpg'
import { getTeam } from "../../services/settingsService";

// Admin panel থেকে এখনো কোনো team member যোগ করা না থাকলে এই default
// (কাল্পনিক নাম, কোনো real public figure না) দেখানো হয়।
const fallbackMembers = [
  { name: "Sarah Ahmed", role: "Event Coordinator", img: TeamImg1, bio: "Events bring people together for shared experience and celebration." },
  { name: "Karim Hasan", role: "Operations Lead", img: TeamImg2, bio: "Events bring people together for shared experience and celebration." },
  { name: "Nabila Rahman", role: "Content Creator", img: TeamImg3, bio: "Events bring people together for shared experience and celebration." },
  { name: "Tanvir Islam", role: "Vendor Relations", img: TeamImg4, bio: "Events bring people together for shared experience and celebration." },
  { name: "Farhana Akter", role: "Marketing Lead", img: TeamImg5, bio: "Events bring people together for shared experience and celebration." },
  { name: "Rafiq Chowdhury", role: "Logistics Manager", img: TeamImg6, bio: "Events bring people together for shared experience and celebration." },
];

export default function Home() {
  const [teamMembers, setTeamMembers] = useState(fallbackMembers);

  useEffect(() => {
    getTeam()
      .then((data) => {
        if (data.items && data.items.length > 0) {
          setTeamMembers(data.items.map((m) => ({
            name: m.name, role: m.role, img: m.image, bio: m.bio,
          })));
        }
      })
      .catch(() => {});
  }, []);

  return (

          <section className="team-page">
            <div className="container">
              <div className="row">
                {teamMembers.map((member, index) => (
                  <div
                    key={index}
                    className={`col-xl-4 col-lg-6 col-md-6 wow fadeIn${
                      index % 2 === 0 ? "Left" : "Right"
                    }`}
                    data-wow-delay={`${(index + 1) * 100}ms`}
                  >
                    <div className="team-one__single">
                      <div className="team-one__img-box">
                        <div className="team-one__img">
                          <img src={member.img} alt={member.name} />
                          <div className="team-one__content">
                            <h4 className="team-one__name">
                              <Link to="team-details">{member.name}</Link>
                            </h4>
                            <p className="team-one__sub-title">{member.role}</p>
                          </div>
                          <div className="team-one__content-hover">
                            <h4 className="team-one__name-hover">
                              <Link to="team-details">{member.name}</Link>
                            </h4>
                            <p className="team-one__sub-title-hover">
                              {member.role}
                            </p>
                            <p className="team-one__text-hover">
                              {member.bio}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>


  );
}
